import React from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';

interface SubmitButtonProps {
  onClick?: () => void;
  isDisabled?: boolean;
  buttonText: string;
  isLoading?: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  onClick,
  isDisabled,
  buttonText,
  isLoading,
}) => (
  <div className="flex flex-1 justify-end">
    <Button
      size="medium"
      variant="contained"
      color="primary"
      onClick={onClick}
      disabled={isDisabled || isLoading}
      type="submit"
    >
      {isLoading ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        <Typography variant="button-l">{buttonText}</Typography>
      )}
    </Button>
  </div>
);

export default SubmitButton;
